<script setup lang="ts">
import { ref } from 'vue';
import { LinkButton, ModalDialog } from '@hfc/ui-core';

const clearAndRestartModal = ref(false);

interface EmitsInterface {
  (event: 'confirm'): void;
}

const emits = defineEmits<EmitsInterface>();

withDefaults(defineProps<{
  text?: string;
}>(), {
  text: 'Clear & Restart',
});

</script>
<template>
  <LinkButton @click="clearAndRestartModal = true">{{ text }}</LinkButton>
  <ModalDialog v-if="clearAndRestartModal === true" @close="clearAndRestartModal = false" :full-height="true" title="Confirmation" confirm-button="Yes" size="sm" @confirm="() => emits('confirm')">
    <template #content>
      <span>Are you sure you want to remove all entered application information and start over?</span>
    </template>
  </ModalDialog>
</template>
